export default class MainNav extends HTMLElement {

    constructor() {
        super();
        this.togglesNav = document.querySelectorAll('.js-toggle-nav')
        this.headerBottomContainer = document.querySelector('.js-header-bottom .container')
        this.mainNavInner = this.querySelector('.main-nav-inner');
        this.visualLoaded = false;
    }

    connectedCallback() {
        document.addEventListener('close-main-nav', (e) => {
            if (this.classList.contains('opened')) {
                this.openCloseNav()
            }
        })

        // Bind toggles
        this.togglesNav.forEach(toggleNav => {
            toggleNav.addEventListener('click', e => {
                e.preventDefault();
                if(this.isWindowResponsive()) {
                    this.openCloseNav();
                }
            });

            toggleNav.addEventListener('mouseenter', e => {
                if(!this.isWindowResponsive()) {
                    this.openCloseNav();
                }
            });

        });

        this.mainNavInner.addEventListener('mouseleave', e =>{
            if(!this.isWindowResponsive()) {
                this.openCloseNav();
            }
        });

        // Update position
        setTimeout(() => {
            this.updatePosition();
        }, 500);
        window.addEventListener('resize', e => {
            this.updatePosition()
        })
        document.addEventListener('scroll', e => {
            this.updatePosition()
        })

        // Close nav on click outside panels
        this.addEventListener('click', (e) => {
            if (e.target === this || e.target.classList.contains('main-nav-inner')) {
                this.openCloseNav();
            }
        })

        // Toggle child panel
        const navLinksWithChildren = this.querySelectorAll('a.has-children')
        navLinksWithChildren.forEach(navLinkWithChildren => {
            navLinkWithChildren.addEventListener('click',e => {
                e.preventDefault();
                this.openChildElement(e);
            });
            navLinkWithChildren.addEventListener('mouseenter',e => {
                e.preventDefault();

                if( this.isWindowResponsive() ) {
                    return
                }
                this.openChildElement(e);
            });
        })

        // Close panel
        const togglesPanel = this.querySelectorAll('.js-toggle-panel')
        togglesPanel.forEach(togglePanel => {
            togglePanel.addEventListener('click', (e) => {
                e.preventDefault()
                e.currentTarget.closest('.nav-panel').classList.remove('opened')
            })
        })

    }

    openChildElement(e) {
        // On gère les états actif des liens
        const activeLinks = e.currentTarget.closest('.nav-panel').querySelectorAll('.active')
        activeLinks.forEach(activeLink => {
            activeLink.classList.remove('active')
        })

        // On ferme tous les panels potentiellement ouverts ...
        const openedPanels = e.currentTarget.closest('.nav-panel').querySelectorAll('.nav-panel.opened')
        openedPanels.forEach(openedPanel => {
            openedPanel.classList.remove('opened')
        })

        // ... et on ouvre le planel cible
        e.currentTarget.classList.add('active')
        e.currentTarget.nextElementSibling.classList.add('opened')
    }

    isWindowResponsive()
    {
        return (window.innerWidth < 992);
    }

    updatePosition() {
        if (this.headerBottomContainer) {
            const rect = this.headerBottomContainer.getBoundingClientRect()
            this.style.setProperty('--pos-top', rect.bottom.toString() + "px")
            this.style.setProperty('--pos-left', (rect.left + 16).toString() + "px")
            this.style.setProperty('--pos-width', rect.width.toString() + "px")
        }

        // Autoconfigure nav max height for desktop
        // Get first level height
        const firstLvl = this.querySelector('.nav-panel-lvl-1 > .nav-panel-body > ul')
        const firstLvlHeight = firstLvl.getBoundingClientRect().height + 48
        this.style.setProperty('--pos-height', firstLvlHeight.toString() + "px")

    }

    openCloseNav() {
        this.classList.toggle('opened')

        // On ferme tous les panels potentiellement ouverts ...
        const openedPanels = this.querySelectorAll('.nav-panel.opened')
        openedPanels.forEach(openedPanel => {
            openedPanel.classList.remove('opened')
        })

        // On supprime les états actifs des liens
        const activeLinks = this.querySelectorAll('.active')
        activeLinks.forEach(activeLink => {
            activeLink.classList.remove('active')
        })

        // On ajoute/retire la classe opened de tous les toggle
        this.togglesNav.forEach(toggleNav => {
            toggleNav.classList.toggle('opened');
        });

        if(this.visualLoaded === false)
        {
           this.querySelectorAll('img').forEach(item => {
                item.setAttribute('src',item.dataset.src);
            });
            this.visualLoaded = true;
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/front/components/MainNav.js